import React, { useEffect, useRef, useState } from "react";
import { Bar } from "react-chartjs-2";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../../DashboardLayout";
import { Button, Form, Table } from "react-bootstrap";
import { handleErrors } from "../../../services/dataManager";
import { fetchAdFillReport } from "../../../services/axios/apiManager";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

function FillRate() {
  const tableRef = useRef(null);
  const navigate = useNavigate();
  const [adNetwork, setAdNetwork] = useState("");
  const [tableData, setTableData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const getAdFillReport = async () => {
    const res = await fetchAdFillReport();
    if (res?.data?.success && res?.data?.data) {
      setTableData(res.data.data);
      if (adNetwork) {
        const temp = res?.data?.data?.filter((f) => f.provider === adNetwork);
        setFilteredData(temp);
      } else {
        setFilteredData(res.data.data);
      }
    } else {
      handleErrors(res, navigate);
    }
  };
  const handleFilterChange = (e) => {
    setAdNetwork(e.target.value);
    if (e.target.value) {
      const temp = tableData?.filter((f) => f.provider === e.target.value);
      setFilteredData(temp);
    } else {
      setFilteredData(tableData);
    }
  };

  const handleReset = () => {
    setAdNetwork("");
    setFilteredData(tableData);
  };

  // Chart data for fill rates
  const chartData = {
    labels: filteredData.map((item) => item.provider),
    datasets: [
      {
        label: "Fill Rate (%)",
        data: filteredData.map(
          (item) => 100 - (item.fill_errors / item.total_ads) * 100
        ),
        backgroundColor: "rgba(255, 159, 64, 0.6)",
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        labels: { color: "#ffffff" },
      },
    },
    scales: {
      x: {
        ticks: { color: "#ffffff" },
      },
      y: {
        beginAtZero: true,
        ticks: {
          color: "#ffffff",
          callback: (v) => `${v}%`,
        },
      },
    },
  };

  useEffect(() => {
    getAdFillReport();
  }, []);

  useEffect(() => {
    const $table = $(tableRef.current);
    const rows = filteredData.map((item) => {
      return [
        item?.provider?.toUpperCase(),
        item.total_ads,
        item.fill_errors,
        100 - ((item.fill_errors / item.total_ads) * 100).toFixed(2),
      ];
    });

    const config = {
      data: rows,
      columns: [
        { title: "Ad Network" },
        { title: "Total Ads" },
        { title: "Fill Errors" },
        { title: "Fill Rate (%)" },
      ],
      destroy: true,
      responsive: true,
      paging: false,
      searching: false,
    };

    if ($.fn.dataTable.isDataTable(tableRef.current)) {
      $table.DataTable().clear().rows.add(rows).draw();
    } else {
      $table.DataTable(config);
    }
    return () => {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $table.DataTable().destroy();
      }
    };
  }, [filteredData]);

  return (
    <DashboardLayout>
      {/* Top Card: Header + Filter */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h5 className="card-title">Filter by Ad Network</h5>
          <div className="row align-items-center mb-3">
            <div className="col-md-3">
              <Form.Select
                className="bg-dark text-light border-light"
                value={adNetwork}
                onChange={handleFilterChange}
              >
                <option value="">All ad networks</option>
                {tableData.map((item, idx) => (
                  <option key={idx} value={item.provider}>
                    {item.provider}
                  </option>
                ))}
              </Form.Select>
            </div>
            <div className="col-md-2">
              <Button variant="success" onClick={handleReset}>
                Reset
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Table Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h5 className="card-title">Fill Rate</h5>
          <p className="card-text">
            Percentage of ad requests successfully filled by ad networks.
          </p>
          <div className="table-responsive">
            <table
              ref={tableRef}
              className="table table-dark table-striped table-hover w-100"
            />
            {tableData.length === 0 && (
              <p className="mt-3 text-center">No data available.</p>
            )}
          </div>
        </div>
      </div>

      {/* Chart Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h6 className="mb-3">Fill Rate by Ad Network</h6>
          <Bar data={chartData} options={chartOptions} />
        </div>
      </div>
    </DashboardLayout>
  );
}

export default FillRate;
